import storeDefault from './default'

export default {
  storeUser: sessionStorage.getItem('storeUser') ? JSON.parse(sessionStorage.getItem('storeUser')) : storeDefault.storeUser,
  storeMch: sessionStorage.getItem('storeMch') ? JSON.parse(sessionStorage.getItem('storeMch')) : storeDefault.storeMch
}



// WEBPACK FOOTER //
// ./src/store/state.js